export default {
  translations: {
    home: {
      welcome: "Hoş geldiniz!",
    },
    header: {
      menu: {
        portal: "Portal",
        planning: "Planlama",
        production: "Üretim",
        requests: "Talepler",
        deliveries: "Teslimatlar",
        stock: "Stok",
        dashboard: "Gösterge Paneli",
      },
      submenu: {
        portal: {
          portalParameters: "Portal Parametreleri",
          parameters: "Parametreler",
          partner: "Ortak",
          agregatedPartner: "Birleştirilmiş Ortak",
          parameterPartner: "Ortak Parametreleri",
          profile: "Profil",
          user: "Kullanıcı",
          passwordChange: "Şifre Değiştirme",
          ssoConfig: "SSO Yapılandırma",
          basicData: "Temel Veri",
          emailGroups: "E-posta Grupları",
        },
        planning: {
          justification: "Gerekçe",
          projects: "Projeler",
          contract: "Sözleşme",
          monthlyForecats: "Aylık Tahminler",
          dailyForecats: "Günlük Tahminler",
          stuffRequest: "Malzeme Talebi",
        },
        production: {
          dailyProductionRelease: "Günlük Üretim Yayını",
          deviationsApproval: "Sapmalar Onayı",
        },
        requests: {
          finishedProduct: "Bitmiş Ürün",
          importRequest: "İthalat Talebi",
        },
        deliveries: {
          fob: "FOB",
          cif: "CIF",
          stuff: "Malzeme",
        },
        stock: {
          brfPartner: "BRF Ortak",
          partner: "Ortak",
        },
        dashboad: {
          productionMonitoring: "Üretim Takibi",
          contractualConsumption: "Sözleşmeli Tüketim",
          import: "İthalat",
          partnerMonitoring: "Ortak Takibi",
        },
      },
      selectPartner: "Bir Ortak Seç",
      partner: "Ortak",
      partnerTooltip: "Gösterilecek verileri seçmek için ortakları listeler!",
      account: {
        myAccount: "Hesabım",
        changePass: "Şifre Değiştirme",
        logout: "Çıkış",
      },
    },
    pages: {
      portalParameters: {
        title: "Portal Parametreleri",
        text: {
          parameter: "Parametre",
          routine: "Rutin",
          value: "Değer",
          newParameter: "Yeni parametre",
          successNew: "Parametre başarıyla eklendi!",
          successUpdate: "Parametre başarıyla güncellendi!",
          successExclusion: "Parametre başarıyla silindi!",
          updateParameterData: "Parametre verilerini güncelle",
          excludeItemQuestionTitle: "Sözleşme Maddesi Silinsin mi?",
          excludeItemQuestionSubTitle:
            "Parametrenin silinmesini talep ettiniz.",
          excludeItemQuestionConfirmation: "İşlemi onaylıyor musunuz?",
          searchRoutine: "Rutin Ara",
        },
      },
      parameters: {
        title: "Parametreler",
        text: {
          parameter: "Parametre",
          properties: "Özellikler",
          value: "Değer",
          newParameter: "Yeni parametre",
          successNew: "Özellik başarıyla eklendi!",
          successUpdate: "Özellik başarıyla güncellendi!",
          successExclusion: "Özellik başarıyla silindi!",
          updateParameterData: "Parametre verilerini güncelle",
          excludeItemQuestionTitle: "Sözleşme Maddesi Silinsin mi?",
          excludeItemQuestionSubTitle:
            "Parametrenin silinmesini talep ettiniz.",
          excludeItemQuestionConfirmation: "İşlemi onaylıyor musunuz?",
          searchRoutine: "Rutin Ara",
          modalTitle: "Sözleşme Maddesi Silinsin mi?",
          modalText: "Parametrenin silinmesini talep ettiniz.",
          modalText2: "Parametre: ",
          modalText3: "Değer: ",
          modalText4: "İşlemi Onaylıyor musunuz?",
        },
      },
      partners: {
        titlePage: "Ortaklar",
        titleList: "Ortakların Listesi",
        titleDetails: "Ortak Detayları",
        text: {
          sapCode: "SAP Kodu",
          sapSupplier: "SAP Tedarikçisi",
          status: "Durum",
          partnersFilter: "Ortakları Filtrele",
          removeFilters: "Filtreleri Kaldır",
          blockPartner: "Ortağı Engelle",
          unlockPartner: "Ortağın Engelini Kaldır",
          blockSuccess: "Ortak başarıyla engellendi!",
          restoreSuccess: "Ortak başarıyla geri yüklendi!",
          savePartnerData: "Ortak verilerini kaydet",
          updateSuccess: "Veriler başarıyla güncellendi!",
          updateFail: "Ortak verileri güncellenemedi.",
          backToList: "Listeye dön",
          partnerEmail: "Ortak E-postası",
          partnerEmails: "Ortak E-postaları",
          partnerDataUpdate: "Ortak Verilerini Güncelle",
          filterOfPartners: "Ortak Filtresi",
          filterOptions:
            "İsme, SAP koduna veya takma isme göre arama yapabilirsiniz.",
          autoCompleteNoOptions: "Seçenek yok, lütfen yöneticiye başvurun.",
        },
      },
      partnerParameters: {
        titlePage: "Ortak Parametreleri",
        text: {
          paramSearch: "Parametre Ara",
          property: "Özellik",
          parameter: "Parametre",
          value: "Değer",
          newParameter: "Yeni parametre",
          updateParameter: "Parametre verilerini güncelle",
          successNewProperty: "Özellik başarıyla eklendi!",
          successUpdateProperty: "Özellik başarıyla güncellendi!",
          successExclusionProperty: "Özellik başarıyla silindi!",
          recoverDataFailure:
            "Ortak Parametreleri verileri alınırken hata oluştu!",
          excludeSuccess: "Parametre başarıyla silindi!",
          excludeItemQuestionTitle: "Sözleşme Maddesi Silinsin mi?",
          excludeItemQuestionSubTitle:
            "Parametrenin silinmesini talep ettiniz.",
          excludeItemQuestionConfirmation: "İşlemi onaylıyor musunuz?",
        },
      },
      user: {
        titlePage: "Kullanıcı",
        text: {
          password: "Şifre",
          generateRandomPassword: "Rastgele şifre oluştur",
          accessFails: "Erişim Hataları",
          profile: "Profil",
          newUser: "Yeni kullanıcı",
          userPartners: "Kullanıcının Ortakları",
          userRelatedPartners: "Kullanıcıya bağlı ortaklar",
          userDataUpdate: "Kullanıcı verilerini güncelle",
          userDataDelete: "Kullanıcı verilerini sil",
          preSelectedFieldsSearch: "Önceden seçilen alanlarla arama yapın!",
          lockedForLogin: "Giriş için engellendi",
          unlockedForLogin: "Giriş için engel kaldırıldı",
          requiredEmailField: "E-posta alanı zorunludur.",
          requiredNameField: "İsim alanı zorunludur.",
          requiredPasswordField: "Şifre alanı zorunludur.",
          requiredPartnetField: "En az bir ortak seçin.",
          invalidEmailField: "Geçersiz e-posta formatı.",
          saveUser: "Kullanıcıyı kaydet",
          successSaveUser: "Kullanıcı başarıyla kaydedildi.",
          deleteUser: "Kullanıcıyı sil",
          successDeleteUser: "Kullanıcı başarıyla silindi.",
          searchFieldNotRecognized: "Tanımlanmamış arama alanı.",
          userWith: "Kullanıcı ile",
          notFounded: "bulunamadı.",
          searchUser: "Kullanıcı ara",
          userRootWarning:
            "Root kullanıcısı tüm ortaklara erişim sağlar, bağlantı kurmanıza gerek yoktur.",
          understand: "Anladım",
          selectFieldandValueToSearch: "Aranacak Alanı ve değeri seçin",
          field: "Alan",
          partners: "Ortaklar",
        },
      },
      password: {
        titlePage: "Şifre Değişikliği",
        text: {
          passwordChange: "Şifre Değişikliği",
          passwordUpdate: "Şifreyi Güncelle",
          actualPassword: "Mevcut Şifre",
          newPassword: "Yeni Şifre",
          newPasswordConfirmation: "Yeni Şifre Onayı",
          passwordChangeSuccess:
            "Şifre başarıyla değiştirildi, giriş ekranına yönlendirileceksiniz!",
          passwordChangeFailure:
            "Şifreniz değiştirilemedi. Adımları gözden geçirip tekrar deneyin!",
          confirm: "İşlemi Onayla",
          confirmQuestion: "Şifreyi {{texto}} istediğinizden emin misiniz?",
          oldPasswordRequired: "Eski şifre girilmelidir!",
          newPasswordRequired: "Yeni bir şifre girilmelidir!",
          newPasswordConfirmationRequired: "Yeni şifrenin onayı gereklidir!",
          passwordsNotMatched: "Şifreler uyuşmuyor!",
          newPasswordAndOldPasswordEqual:
            "Eski şifre ile yeni şifre aynı olamaz!",
          pleaseVerify: "Lütfen kontrol edin",
          verifyItemPlural: "aşağıdaki maddeler:",
          verifyItemSingular: "aşağıdaki madde:",
          fillingError: "Doldurma Hataları",
        },
      },
      basicData: {
        titlePage: "Temel Veriler",
        text: {
          sapSupplierCode: "SAP Tedarikçi Kodu",
          sapClientCode: "SAP Müşteri Kodu",
          partners: "Ortaklar",
          sku: "Sku",
          distributionCenter: "Dağıtım Merkezi",
        },
      },
      emailsGroups: {
        titlePage: "E-posta Grupları",
        text: {
          emails: "E-postalar",
          routine: "Rutin",
          routines: "Rutinler",
          registeredEmails: "Kayıtlı E-postalar",
          registeredGroups: "Kayıtlı Gruplar",
          emailCreatedWithSuccess: "E-posta başarıyla oluşturuldu",
          emailRemovedWithSuccess: "E-posta başarıyla silindi!",
          registerUpdatedWithSuccess: "Kayıt başarıyla güncellendi",
          savingDataFrom: "Veri kaydediliyor: ",
          groupRemovedWithSuccess: "Grup başarıyla silindi",
          emailRegister: "E-posta kaydet",
          emailRemove: "E-posta sil",
          groupRegister: "Grup kaydet",
          groupRemove: "Grup sil",
          emailAddToGroupWithSuccess: "E-posta gruba başarıyla eklendi",
          linkedEmails: "Bağlantılı E-postalar",
          addEmail: "E-posta ekle",
          routineCreatedWithSuccess: "Rutin başarıyla oluşturuldu",
          routineAddedToGroupWithSuccess: "Rutin gruba başarıyla eklendi",
          routineRemovedWithSuccess: "Rutin başarıyla silindi",
          linkedRoutines: "Bağlantılı Rutinler",
          addRoutine: "Rutin ekle",
        },
      },
      justifications: {
        titlePage: "Gerekçeler",
        text: {
          successNewProperty: "Özellik başarıyla eklendi!",
          successUpdateProperty: "Özellik başarıyla güncellendi!",
          justificationExclusionWithSuccess: "Gerekçe başarıyla silindi!",
          newJustification: "Yeni gerekçe",
          updateParametersData: "Parametre verilerini güncelle",
          excludeItemQuestionTitle: "Gerekçe Silinsin mi?",
          excludeItemQuestionSubTitle: "Gerekçenin silinmesini talep ettiniz.",
          excludeItemQuestionConfirmation: "İşlemi onaylıyor musunuz?",
          justification: "Gerekçe",
        },
      },
      projects: {
        titlePage: "Projeler",
        text: {
          successNewProject: "Proje başarıyla eklendi!",
          successUpdateProject: "Proje başarıyla güncellendi!",
          projectExclusionWithSuccess: "Proje başarıyla silindi!",
          newProject: "Yeni proje",
          updateProjectData: "Proje verilerini güncelle",
          excludeItemQuestionTitle: "Proje Silinsin mi?",
          excludeItemQuestionSubTitle: "Projenin silinmesini talep ettiniz.",
          excludeItemQuestionConfirmation: "İşlemi onaylıyor musunuz?",
          project: "Proje",
          projectName: "Proje Adı",
        },
      },
      contracts: {
        titlePage: "Sözleşmeler",
        titleList: "Sözleşme Listesi",
        text: {
          newContract: "Yeni sözleşme",
          contractItems: "Sözleşme Maddeleri",
          contractItem: "Sözleşme Maddesi",
          contract: "Sözleşme",
          warningStartDate:
            "Başlangıç Tarihi, Bitiş Tarihinden önce olmalıdır!",
          warningContractNumber:
            "Bu ortak için zaten bu sözleşme numarası mevcut, mükerrerliğe izin verilmeyecek, lütfen düzeltin!",
          saveContract: "Sözleşmeyi Kaydet",
          informContractNumber: "Sözleşme numarasını girin",
          saveWithSuccess: "Sözleşme başarıyla kaydedildi!",
          excludeContract: "Sözleşmeyi Sil",
          excludeWithSuccess: "Sözleşme başarıyla silindi!",
          excludeError: "Sözleşmeyi silmeye çalışırken hata oluştu",
          addItemToContract: "Sözleşmeye madde ekle",
          updateContractItem: "Sözleşme maddesini güncelle",
          addItemsToContract: "Sözleşmeye maddeler ekle",
          contractItemDeleteWithSuccess: "Sözleşme Maddesi başarıyla silindi!",
          contractItemDeleteError: "Sözleşme maddesi silinirken hata oluştu!",
          contractItemUpdateWithSuccess:
            "Sözleşme Maddesi başarıyla güncellendi!",
          itemUpdateWithSuccess: "Madde başarıyla güncellendi!",
          generateMonthlyForecast: "Aylık Tahmin Oluştur",
          monthlyForecats: "Aylık Tahminler",
          monthlyForecatsContinue:
            "Aylık tahmin oluşturmaya devam etmek istiyor musunuz?",
          reverseForecast: "Tahmini Geri Al",
          reverseForecastProceed:
            "Tahmin Geri Almayı sürdürmek istiyor musunuz?",
          reverseForecastSuccess: "Tahmin başarıyla geri alındı!",
          reverseForecastUnsuccessful: "Tahmin Geri Alınamadı!",
          contractForecast: "Sözleşme Tahmini",
          forPartner: "ortak için",
          andSku: "ve SKU için",
          generatedWithSuccess: "başarıyla oluşturuldu!",
          contractNumber: "Sözleşme Numarası",
          priceFrequency: "Fiyat Güncelleme Sıklığı (Ay)",
          agreedPenalty: "Kararlaştırılan Ceza",
          penalty: "Ceza",
          beginningOfTerm: "Başlangıç Tarihi *",
          endOfTerm: "Bitiş Tarihi *",
          shippingMode: "Nakliye Modu *",
          modalExit: "Modal'dan çık",
          yearReference: "Referans Yılı",
          anualQuantity: "Yıllık Miktar",
          excludeItemQuestionTitle: "Sözleşme Silinsin mi?",
          excludeItemQuestionSubTitle: "Sözleşmenin silinmesini talep ettiniz.",
          excludeItemQuestionConfirmation: "İşlemi onaylıyor musunuz?",
          excludeItemQuestionTitle2: "Sözleşme Maddesi Silinsin mi?",
          excludeItemQuestionSubTitle2:
            "Sözleşme maddesinin silinmesini talep ettiniz.",
          excludeItemQuestionConfirmation2: "İşlemi onaylıyor musunuz?",
          removeItem: "Maddeyi Sil",
          blockStuff: "Malzemeyi Engelle",
          unblockStuff: "Malzemenin Engelini Kaldır",
          project: "Proje",
          titlePenalty: "Kararlaştırılan Ceza",
          contractDetails: "Sözleşme Detayları",
          contractModalTitle: "SAP Sözleşmeleri ve Kaynakları",
        },
      },
      monthlyForecast: {
        titlePage: "Aylık Tahmin",
        text: {
          defineBasePlan: "Temel planı belirle",
          suggestChanges: "Değişiklik öner",
          approveDisapproveProposal: "Teklifi Onayla/Reddet",
          frozenAndDiarized: "Dondurulmuş ve Günlükleştirilmiş",
          allStepsHaveBeenCompleted: "Tüm adımlar tamamlandı.",
          includingForecastGeneration: "Tahmin oluşturmayı içeriyor.",
          itIsStillPossibleToChangeContractData:
            "Sözleşme verilerini değiştirmek hala mümkün,",
          howeverRecreateTheForecast:
            "Ancak, oluşturulmuş SKU'lar ve dönemler için tahmini yeniden oluşturmak mümkün olmayacaktır!",
          theFinalStep:
            "Son adım, son tahmin oluşturulduktan sonra eklenen SKU'lar için yapılacaktır:",
          contractConsumption: "Sözleşme Tüketimi",
          exitModal: "Modal'dan çık",
          sAPSupplierCode: "SAP tedarikçi kodu",
          contractNumber: "Sözleşme Numarası",
          percentageConsumed: "Tüketilen Yüzde",
          approvalDataTitle:
            "Aşağıdaki listedeki seçilen öğelerin verilerini onaylayın ve bir sonraki aşamaya geçin!",
          approvalDataTitle2:
            "Eğer oluşturulmamışsa, bu işlem Günlük Tahmini oluşturacaktır!",
          contractNotSelected: "Sözleşme seçilmedi",
          withoutContract: "Sözleşme Yok!",
          integratedSelectedItems:
            "Listede seçilen {{quantityItems}} öğe başarıyla entegre edildi!",
          integratedSelectedItems2:
            "Listede seçilen öğe başarıyla entegre edildi!",
          updatedSelectedItems:
            "Listede seçilen {{quantityItems}} öğe başarıyla güncellendi!",
          updatedSelectedItems2: "Listede seçilen öğe başarıyla güncellendi!",
          errorSelectedItems:
            "Listede seçilen {{quantityItems}} öğe gönderildi, ancak bazıları başarıyla işlenmedi!",
          errorSelectedItems2: "Seçilen öğe güncellenemedi!",
          proposalQuantityIsWrong:
            "Önerilen Miktar Alanı, miktardan farklı bir değerle doldurulmuştur, lütfen bir Gerekçe belirtin!",
          rememberThisOperation:
            "Bu işlemin SAP entegrasyonunu da içerdiğini unutmayın!",
          selectedItemsNextForecast:
            "Listede seçilen {{quantityItems}} öğe onaylandı ve bir sonraki 'WorkFlow' aşamasında yer alıyor!",
          selectedItemsNextForecast2:
            "Listede seçilen öğe onaylandı ve bir sonraki 'WorkFlow' aşamasında yer alıyor!",
          selectedItemsNextForecastError:
            "Listede seçilen {{quantityItems}} öğe onaylanmadı ve önceki 'WorkFlow' aşamasında kaldı!",
          selectedItemsNextForecastError2:
            "Listede seçilen öğe onaylanmadı ve önceki 'WorkFlow' aşamasında kaldı!",
          selectedItemsProcessedWithError:
            "Listede seçilen {{quantityItems}} öğe hatalı işlendi!",
          selectedItemsProcessedWithError2: "Seçilen öğe doğru işlenmedi!",
          selectedItemsDoesNotProcessed:
            "Listede seçilen {{quantityItems}} öğe doğru işlenmedi!",
          selectedItemsDoesNotProcessed2: "Seçilen öğe doğru işlenmedi!",
          monthYearRef: "Ay yıl ref.",
          processingRequest: "Talebinizin işlenmesi yaklaşık",
          processingRequest2: "saniye sürecek. Lütfen bekleyin!",
          negativeValues: "Negatif değerler kabul edilemez!",
          undoGeneratedForecasts: "Oluşturulmuş Tahminleri Geri Al",
          viewRatioData: "Oran verilerini görüntüle",
          enablesFilteringTheLinesInTheGridBelow:
            "Aşağıdaki ızgaradaki satırları filtrelemeyi etkinleştirir!",
          disableFilteringTheLinesInTheGridBelow:
            "Filtrelemeyi devre dışı bırakır ve aşağıdaki ızgaradaki tüm satırları döndürür!",
          saveChanges:
            "Aşağıdaki ızgarada seçilen öğedeki değişiklikleri kaydet, ancak bir sonraki aşamaya geçme!",
          uploadCsv:
            "Bir CSV dosyasını yükleyin ve aşağıdaki listeyi güncelleyin!",
          downloadCsv: "Bir CSV dosyası indirin, güncelleyin ve yükleyin!",
          continueForecast: "Aylık Tahmine devam etmek istiyor musunuz?",
          reproveData:
            "Aşağıdaki listede seçilen öğelerin verilerini reddedin ve önceki aşamaya geri döndürün!",
          sendDataToSap: "SAP'ye verileri gönderin ve aşamayı değiştirmeyin!",
          importExcel: "Excel Sayfası İthalatı!",
          csvWithSuccess: "CSV Başarıyla işlendi!",
          csvWithError: "CSV işlenemedi",
        },
      },
      dailyForecast: {
        titlePage: "Günlük Tahmin",
        text: {
          exitModal: "Modal'dan çık",
          whenToMoveProduction: "Üretim ne zaman taşınacak?",
          forecastDate: "Tahmin Tarihi",
          resetForecastForTheDay: "Bu işlem günün tahminini sıfırlayacaktır",
          movingQuantity: " miktarınızı şu SKU'dan taşıyorsunuz",
          fromSku: "SKU'dan",
          forTheDay: "gün için",
          movePlan: "Planı taşı",
          approvesAllItems:
            "Aşağıdaki listedeki tüm öğeleri onaylayın ve bir sonraki aşamaya geçin!",
          withoutContract: "Sözleşme Yok!",
          gridItemsUpdatedSuccessfully:
            "Izgaradaki öğeler başarıyla güncellendi!",
          gridItemsProblems: "Izgaradaki öğeler işlenirken sorun oluştu!",
          rememberOperationWithSap:
            "Bu işlemin SAP entegrasyonunu da içerdiğini unutmayın!",
          allItemsWereApproved:
            "Tüm öğeler onaylandı ve bir sonraki 'WorkFlow' aşamasında yer alıyor!",
          allItemsWereNotApproved:
            "Tüm öğeler onaylanmadı ve önceki 'WorkFlow' aşamasında kaldı!",
          itemsWereNotProcessed: "Öğeler düzgün işlenmedi!",
          itemUpdatedSuccessfully: "Öğe başarıyla güncellendi!",
          errorSavingItem: "Öğe kaydedilirken hata oluştu!",
          exceededMonthlyAmount: "Belirtilen miktar aylık limitin üzerinde.",
          monthlyTotalReported: "Bildirilmiş toplam aylık miktar:",
          maxAvailable: "Maksimum mevcut:",
          referenceMonthYear: "Referans Ay/Yıl:",
          negativeValues: "Negatif değerler kabul edilemez!",
          enablesFilteringGrid:
            "Aşağıdaki ızgaradaki satırları bir tarih aralığına göre filtrelemeyi etkinleştirir!",
          disableFiltersAndReturn:
            "Filtrelemeyi devre dışı bırakır ve aşağıdaki ızgaradaki tüm satırları döndürür!",
          viewRatioData: "Oran verilerini görüntüle",
          saveChangesToSelectedItem:
            "Aşağıdaki ızgarada seçilen öğedeki değişiklikleri kaydet, ancak bir sonraki aşamaya geçme!",
          uploadCsvFile:
            "Bir CSV dosyasını yükleyin ve aşağıdaki listeyi güncelleyin!",
          downloadCsvFile: "Bir CSV dosyası indirin, güncelleyin ve yükleyin!",
          doYouWantContinue: "Günlük Tahmine devam etmek istiyor musunuz?",
          reproveAllItems:
            "Aşağıdaki listedeki tüm öğelerin verilerini reddedin ve önceki aşamaya geri döndürün!",
          excelImport: "Excel Sayfası İthalatı!",
          csvWithSuccess: "CSV Başarıyla işlendi!",
          csvWithFail: "CSV işlenemedi",
          movePlanWithSuccess: "Plan başarıyla taşındı!",
          movePlanWithFail: "Plan taşınamadı!",
          dailyForecastStep: "Günlük Tahmin Adımı",
          sapSupplierCode: "SAP Tedarikçi Kodu",
          contractConsume: "Sözleşme Tüketimi",
          defineBasePlan: "Temel Planı Tanımla",
          approve: "Onayla",
          disapprove: "Reddet",
          itemsReleasedToLaunchProduction:
            "Üretimi başlatmak için serbest bırakılan öğeler",
          optional: "İsteğe Bağlı",
          allStepsCompleted:
            "Tüm adımlar tamamlandı. Tahmin oluşturma dahil. Sözleşme verileri hala değiştirilebilir, ancak zaten oluşturulmuş SKU'lar için Tahmin yeniden oluşturulamaz!",
        },
      },
      stuffRequest: {
        titlePage: "Hammadde Talebi",
        text: {
          indicateNeed: "İhtiyacı Belirt",
          proposeFulfillment: "Karşılama Önerisi",
          partnerAcceptance: "Ortak Kabulü",
          approveRequestAndGeneratePurchaseOrder:
            "Talebi Onayla ve Satın Alma Siparişini Oluştur",
          requestedItems: "Talep Edilen Öğeler",
          rawMaterialRequest: "Hammadde Talebi",
          itemsSavedSuccessfully: "Öğeler başarıyla kaydedildi!",
          errorTryingToSave: "Kaydetme hatası!",
          itemDeletedSuccessfully: "Öğe başarıyla silindi!",
          errorTryingToDelete: "Silme hatası!",
          itemSaveSuccessfully: "Öğe başarıyla kaydedildi!",
          itemRejectedSuccessfully: "Öğe başarıyla reddedildi!",
          errorTryingFailed: "Reddetme hatası!",
          itemsDeletedSuccessfully: "Öğeler başarıyla silindi!",
          itemApprovedSuccessfully: "Öğe başarıyla onaylandı!",
          errorTryingToApprove: "Onay hatası!",
          proposedDateEarlier: "Önerilen Tarih, Talep Tarihinden önce olamaz!",
          uploadDateEarlier: "Yükleme Tarihi, Talep Tarihinden önce olamaz!",
          itemAddedSucessfully: "Öğe başarıyla eklendi!",
          errorTryingToInclude: "Ekleme hatası!",
          saveChangesToSelectedData:
            "Aşağıdaki ızgarada seçilen tüm öğelerdeki değişiklikleri kaydet, ancak bir sonraki aşamaya geçme!",
          enablesFiltering:
            "Aşağıdaki ızgaradaki satırları bir tarih aralığına göre filtrelemeyi etkinleştirir!",
          disableFilters:
            "Filtrelemeyi devre dışı bırakır ve aşağıdaki ızgaradaki tüm satırları döndürür!",
          addLine: "Satır ekle",
          uploadCsv:
            "Bir CSV dosyasını yükleyin ve aşağıdaki listeyi güncelleyin!",
          downloadCsv: "Bir CSV dosyası indirin, güncelleyin ve yükleyin!",
          reproveItemsFromSelectedData:
            "Aşağıdaki listede seçilen öğelerin verilerini reddedin ve önceki aşamaya geri döndürün!",
          proceedWithRequest:
            "Hammadde Talebi ile devam etmek istiyor musunuz?",
          deleteSelected: "Seçilenleri Sil",
          proceedWithDelete:
            "Seçilen öğelerin silinmesiyle devam etmek istiyor musunuz?",
          excelImport: "Excel Sayfası İthalatı!",
          filterGridBy: "Izgarayı Filtrele:",
        },
      },
      dailyProductionRelease: {
        titlePage: "Günlük Üretim Yayını",
        text: {
          approveItemData:
            "Aşağıdaki listede seçilen öğelerin verilerini onaylayın ve bir sonraki aşamaya geçin!",
          approvalOfDeviations: "Sapmaların Onayı",
          thePlural: "Öğeler",
          itemsSuccessfullyIntegrated:
            "Izgaradaki seçilen öğeler başarıyla entegre edildi!",
          itemSuccessfullyIntegrated:
            "Izgaradaki öğe başarıyla entegre edildi!",
          itemsSuccessfullyUpdated:
            "Izgaradaki seçilen öğeler başarıyla güncellendi!",
          itemSuccessfullyUpdated: "Izgaradaki öğe başarıyla güncellendi!",
          itemsSuccessfullyFail: "Izgaradaki seçilen öğeler düzgün işlenemedi!",
          itemSuccessfullyFail: "Izgaradaki öğe düzgün işlenemedi!",
          adhesionLessThan:
            "{{valorAderencia}}%'den düşük yapışma için alanların doldurulması gerekir: Gerekçe, Ay içinde telafi et ve Ne zaman?",
          rememberSapIntegration:
            "Bu işlemin SAP entegrasyonunu da içerdiğini unutmayın!",
          itemsApprovedForNextStep:
            "Izgaradaki seçilen öğeler onaylandı ve bir sonraki 'WorkFlow' aşamasında yer alıyor!",
          itemApprovedForNextStep:
            "Izgaradaki öğe onaylandı ve bir sonraki 'WorkFlow' aşamasında yer alıyor!",
          itemsDontApprovedForNextStep:
            "Izgaradaki seçilen öğeler onaylanmadı ve önceki 'WorkFlow' aşamasında kaldı!",
          itemDontApprovedForNextStep:
            "Izgaradaki öğe onaylanmadı ve önceki 'WorkFlow' aşamasında kaldı!",
          itemsNotProcessedProperly: "Izgaradaki öğeler düzgün işlenmedi!",
          itemNotProcessedProperly: "Izgaradaki öğe düzgün işlenmedi!",
          payWithinMonth: "Ay içinde telafi edilecek mi?",
          when: "Ne zaman?",
          for: "İçin",
          negativeValuesNotAllowed: "Negatif değerlere izin verilmez!",
          enablesFilteringByDate:
            "Aşağıdaki ızgaradaki satırları bir tarih aralığına göre filtrelemeyi etkinleştirir!",
          disableFilter:
            "Filtrelemeyi devre dışı bırak ve aşağıdaki ızgaradaki tüm satırları geri döndür!",
          moveSelectedLine: "Seçilen satırı Adım 1'e taşı",
          saveChangesWithoutAdvance:
            "Aşağıdaki ızgarada seçilen öğelerdeki değişiklikleri kaydet, ancak bir sonraki aşamaya geçme!",
          wishContinue: "Devam etmek istiyor musunuz?",
          reproveDataAndBackStep:
            "Aşağıdaki listede seçilen öğelerin verilerini reddedin ve önceki aşamaya geri döndürün!",
          uploadCsvFile:
            "Bir CSV dosyasını yükleyin ve aşağıdaki listeyi güncelleyin!",
          downloadCsvFile:
            "Bir CSV dosyasını indirin, güncelleyin ve yükleyin!",
          excelImport: "Excel Sayfası İthalatı!",
          productionRelease: "Üretim Yayını",
          gripConfirmation: "SAP'ye üretim entegrasyonu ve yapışmanın onayı",
        },
      },
      deliveriesFob: {
        pageTitle: "FOB Yüklerinin Takibi",
        text: {
          requiredField: "Zorunlu Alan!",
          selectPartnerFirst:
            "Bu sayfaya erişmeden önce bir ortağı seçmelisiniz.",
          clifor: "Clifor",
          truckPlate: "Kamyon Plakası",
          trailerPlate: "Çekici Plakası",
          orderItems: "Sipariş Kalemleri",
          showOrderItems: "Sipariş Kalemlerini Göster",
          enableFiltering:
            "Aşağıdaki ızgaradaki satırları filtrelemeyi etkinleştir!",
          disableFiltering:
            "Filtreyi devre dışı bırak ve aşağıdaki ızgaradaki tüm satırları geri getir!",
          filterFobCargo: "FOB Yüklerini Filtrele",
          itemsOfOrder: "Sipariş Kalemleri",
        },
      },
      deliveriesCif: {
        pageTitle: "CIF Yüklerinin Takibi",
        text: {
          requiredField: "Zorunlu Alan!",
          selectPartnerFirst:
            "Bu sayfaya erişmeden önce bir ortağı seçmelisiniz.",
          clifor: "Clifor",
          truckPlate: "Kamyon Plakası",
          trailerPlate: "Çekici Plakası",
          orderItems: "Sipariş Kalemleri",
          showOrderItems: "Sipariş Kalemlerini Göster",
          enableFiltering:
            "Aşağıdaki ızgaradaki satırları filtrelemeyi etkinleştir!",
          disableFiltering:
            "Filtreyi devre dışı bırak ve aşağıdaki ızgaradaki tüm satırları geri getir!",
          filterCifCargo: "CIF Yüklerini Filtrele",
          itemsOfOrder: "Sipariş Kalemleri",
          loadingHistory: "CIF Yükleme Geçmişi",
          dataSaved: "Veriler başarıyla kaydedildi.",
          selectedOrderAndItemNotFound: "Seçilen sipariş ve kalem bulunamadı.",
          modalTitle: "CIF Yükleme Geçmişi",
          modalDescriptionSuccess: "Veriler başarıyla kaydedildi.",
          modalDescriptionError: "Değişiklikler kaydedilemedi.",
          tooltipShowLoadingDeliveries: "Yükleme geçmişini göster",
          tooltipDeleteLoadingHistory: "Yükleme geçmişini silmeyi geri al",
          tooltipAddNewLoad: "Yeni yükleme ekle",
          tooltipDownloadFileAndUpdate: "CSV dosyasını indir ve güncelle!",
          tooltipUploadFileAndUpdateList:
            "CSV dosyasını yükle ve aşağıdaki listeyi güncelle!",
          tooltipSaveChanges: "Yapılan tüm değişiklikleri kaydet.",
          tooltipExitModal: "Modal'dan çık",
        },
      },
      deliveriesRawMaterial: {
        pageTitle: "Ham Madde Yüklerinin Takibi",
        text: {
          truckPlate: "Kamyon Plakası",
          saveAllChanges: "Yapılan tüm değişiklikleri kaydet.",
        },
      },
      stockPartnerBrf: {
        pageTitle: "Stok/BRF Ortağı",
        text: {
          thisFieldCannotBeEmpty: "Bu alan boş bırakılamaz!",
          thisFieldCanOnlyContainNumbers: "Bu alan sadece rakamlar içerebilir!",
          thisFieldCannotBeLonger: "Bu alan 5 karakterden uzun olamaz!",
          unableToFindIndustrializationCenter:
            "Bu ortak için bir Endüstrileştirme Merkezi bulunamadı!",
          csvDownload: "CSV dosyasını indir ve güncelle!",
          brfPartner: "BRF Ortağı",
        },
      },
      stockPartnerNamed: {
        pageTitle: "Stok/Ortak",
        text: {
          thisFieldCannotBeEmpty: "Bu alan boş bırakılamaz!",
          thisFieldCanOnlyContainNumbers: "Bu alan sadece rakamlar içerebilir!",
          thisFieldCannotBeLonger: "Bu alan 5 karakterden uzun olamaz!",
          unableToFindIndustrializationCenter:
            "Bu ortak için bir Endüstrileştirme Merkezi bulunamadı!",
          selectPartner: "Bir Ortak Seçmelisiniz!",
          csvDownload: "CSV dosyasını indir ve güncelle!",
          partner: "Ortak",
        },
      },
      finishiedProduct: {
        pageTitle: "Tamamlanmış Ürün",
        text: {
          availableProductsList: "Mevcut Ürünler Listesi",
          prioritizeDeliveries: "Teslimatları Önceliklendir",
          generatePreOrder: "Ön Sipariş Oluştur",
          productsAlreadyRequested: "Zaten Talep Edilen Ürünler",
          withoutContract: "Sözleşme Yok!",
          finishiedProduct: "Tamamlanmış Ürün",
          inconsistencyInReportedBalance: "Bildirilen bakiyede tutarsızlık",
          have: "Var",
          that: "ki",
          exceedingBalance: "bakiye aşılmış durumda",
          wantProceed: "Düzeltmeden devam etmek istiyor musunuz?",
          informOriginCenter: "Merkez Alanını Doldurmanız Gerekiyor!",
          informDestinyCenter: "Teslimat Merkezini Doldurmanız Gerekiyor!",
          informOriginDeposit: "Depo Alanını Doldurmanız Gerekiyor!",
          informContractSap: "SAP Sözleşme Alanını Doldurmanız Gerekiyor!",
          deliveryDateCannotBeEarlier:
            "Teslimat Tarihi, Mevcut Tarihten önce olamaz!",
          deliveryDateCannotBeBefor:
            "Teslimat Tarihi, Eklenme Tarihinden önce olamaz!",
          quantityMoreThanZero: "Belirtilen miktar sıfırdan büyük olmalıdır!",
          requiredLoadDate: "Yükleme Tarihi Girilmelidir!",
          originDontInformed: "Yükleme kaynağı belirtilmedi.",
          deliveryDateNeedInformed: "Teslimat Tarihi Girilmelidir!",
          requiredDestinyCenter: "Teslimat Merkezi Girilmelidir!",
          loadingDateMustBeFilled: "Yükleme tarihi doldurulmalıdır",
          thePlural: "Ürünler",
          itemsUpdatedSuccessfully:
            "Izgarada seçilen öğeler başarıyla güncellendi!",
          itemUpdatedSuccessfully:
            "Izgarada seçilen öğe başarıyla güncellendi!",
          itemsProcessedWithProblems:
            "Izgarada seçilen öğeler işlenirken sorunlar oluştu!",
          itemProcessedWithProblems: "Izgarada seçilen öğe işlenemedi!",
          totalQuantityReported: "Bildirilen toplam miktar (paletlerde)",
          isLess: "minimum palet miktarının altında",
          isGreater: "maksimum palet miktarının üstünde",
          itemsWithInsufficientBalance:
            "Bakiyesi yetersiz olan ürünler var, lütfen bakiyeyi kontrol edin.",
          itemWithInsufficientBalance:
            "Bakiyesi yetersiz olan ürün, sipariş verilemiyor, lütfen bakiyeyi kontrol edin.",
          insufficientBalance: "Yetersiz Bakiye",
          wantProceed2:
            "Tamamlanmış Ürün talebine devam etmek istiyor musunuz?",
          cancelSelectedOrder: "Seçilen sipariş(ler) iptal edilsin mi?",
          moveSelectedOrder: "Seçilen sipariş(ler) Adım 2'ye taşınsın mı?",
          saveChanges:
            "Aşağıdaki ızgaradaki tüm seçilen öğelerdeki değişiklikleri kaydedin, ancak bir sonraki aşamaya geçmeyin!",
          goToNextStep: "Bir sonraki aşamaya geç",
          itemApproveSuccessfully: "Öğe başarıyla onaylandı",
          wantProccedClickYes:
            "Tamamlanmış ürün talebine devam etmek için bilgileri doldurun ve EVET'e tıklayın.",
        },
      },
      importRequest: {
        pageTitle: "İthalat Talebi",
        text: {
          unableToRecoverDate:
            "Veriler kurtarılamadı! Uygulama şu hatayı verdi:",
          requiredSelectedPartner: "Bir ortak seçmelisiniz!",
          dataSavedSuccessfully: "Veriler başarıyla kaydedildi.",
          errorProcessingFile: "Dosya işlenirken hata oluştu.",
          ordersUpdatedSuccessfully: "Siparişler başarıyla güncellendi!",
          orderUpdatedSuccessfully: "Sipariş başarıyla güncellendi!",
          errorSavingOrders: "Siparişler kaydedilemedi!",
          errorSavingOrder: "Sipariş kaydedilemedi!",
          boardingInstructionSequenceNo: "Yükleme Talimatı Sıra No",
          boardingSequenceNo: "Yükleme Sıra No",
          purchasingDocument: "Satın Alma Belgesi - PO",
          item: "Kalem - PO",
          supplier: "Tedarikçi - PO",
          name: "Adı - PO",
          materialPo: "Malzeme - PO",
          acronym: "Kısaltma - PO",
          description: "Kısa Açıklama - PO",
          orderQuantity: "Sipariş Miktarı - PO",
          shipmentQuantity: "Sevk Miktarı - BEM",
          etd: "ETD",
          eta: "ETA",
          shippingDate: "Sevk Tarihi",
          estatiscalShippingDate: "İstatistiksel Sevk Tarihi",
          commodityReceiptDate: "Mal Kabul Tarihi",
          registrationDate: "Kayıt Tarihi - DES",
          month: "Ay",
          week: "Hafta",
          deviationReceiving: "Alım Sapması",
          justify: "Gerekçe",
          causer: "Neden",
          observation: "Gözlem",
          orderIntegratedSuccessfully: "Sipariş(ler) başarıyla entegre edildi!",
          errorInIntegration: "Entegrasyon hatası!",
          justifyRequest:
            "Alım sapması için gerekçe girilmelidir: +- 7 iş günü",
          saveAllLines: "Tüm satırları kaydedin.",
          csvDownload: "Toplu güncelleme için CSV dosyasını indir.",
          loadCsvFile: "CSV dosyasını yükleyin.",
          watchOrderHistory: "İthalat sipariş geçmişini görüntüleyin.",
          filter: "Filtre",
          sapIntegrate: "SAP Entegre",
          config: "Ayarlar",
          filterImportOrders: "İthalat Siparişlerini Filtrele",
          order: "Sipariş",
          material: "Malzeme",
          shippingInstruction: "Yükleme Talimatı",
          sheetImport: "Excel Sayfası İthalatı!",
          daysBetweenRequired: "'Gün aralığı' parametresi doldurulmalıdır.",
          timeRequired: "'Saat' parametresi doldurulmalıdır.",
          saveConfigs: "Ayarları Kaydet",
          exitConfigs: "Ayarları Kapat",
          waitPlease: "Lütfen bekleyin ..",
          differenceLimit: "ETA ile Sevk Tarihi arasındaki gün farkı limiti:",
          timeForAutomaticRoutine: "Otomatik rutin için saat:",
          exitModal: "Modal'dan çık",
          eventDate: "Olay Tarihi",
          orderImportId: "İthalat Sipariş ID'si",
          responsible: "Sorumlu",
          csvDownload2: "CSV dosyasını indir ve güncelle!",
          orderHistory: "İthalat Sipariş Geçmişi",
        },
      },
      dashboardProductionMonitoring: {
        pageTitle: "Üretim Takibi Gösterge Paneli",
        text: {
          otif: "OTIF",
          downloadCsv: "CSV dosyasını indir ve güncelle!",
          initial: "Başlangıç",
          final: "Bitiş",
          dateTypeDoesNotExist: "Tarih türü mevcut değil:",
          loadingDataWaitPlease: "Veriler yükleniyor, lütfen bekleyin ...",
          percentageOfJustifications: "Gerekçelerin Yüzdesi:",
          initialDate: "Başlangıç Tarihi",
          finalDate: "Bitiş Tarihi",
          portalContract: "Portal Sözleşmesi",
          partners: "Ortaklar",
          updateDashboardWithFilters:
            "Seçilen filtrelerle gösterge panelini güncelleyin",
          applyFilters: "Filtreleri Uygula",
          filterDate:
            "Tarih filtresi haftanın başlama ve bitiş tarihlerine göre ayarlanacaktır.",
          contractFilter:
            "Sözleşme filtresi, seçilen ortaklara göre doldurulacaktır.",
          plannedProducedWeekly: "HAFTALIK PLANLANAN X ÜRETİLEN",
          plannedProducedDaily: "GÜNLÜK PLANLANAN X ÜRETİLEN",
          justifications: "GEREKÇELER",
          total: "TOPLAM",
          remnant: "ARTIK",
          breaking: "KIRILMA",
          quantity: "MİKTAR",
          planned: "PLANLANAN",
          produced: "ÜRETİLEN",
        },
      },
      dashboardContractualComsumption: {
        pageTitle: "Sözleşme Tüketim Gösterge Paneli",
        text: {
          contractualComsumption: "Sözleşme Tüketimi",
          loadingData: "Veriler yükleniyor, lütfen bekleyin...",
          portalContract: "PORTAL SÖZLEŞMESİ",
          sapContract: "SAP SÖZLEŞMESİ",
          updateDashboardWithSelectedFilters:
            "Seçilen filtrelerle gösterge panelini güncelleyin",
          minimal: "MİNİMUM",
          variation: "DEĞİŞİM",
          maximum: "MAKSİMUM",
          percentageByContractTime: "Sözleşme Süresine Göre Yüzde",
          volume: "HACİM",
          consumed: "TÜKETİLEN",
          totalContract: "SÖZLEŞME TOPLAMI",
          percentageOfQuantityProducedBeforeTheTotalPlan:
            "Toplam Plan Öncesi Üretilen Miktarın Yüzdesi",
          portalContractNumber: "Portal Sözleşme No",
          sapContractNumber: "SAP Sözleşme No",
          downloadCsv: "CSV dosyasını indir ve güncelle!",
        },
      },
      dashboardImport: {
        pageTitle: "İthalat Gösterge Paneli",
        text: {
          import: "İthalat",
          seqNoBoardingInstruction: "Yükleme Talimatı Sıra No",
          boardingSequenceNumber: "Yükleme Sıra No",
          csvDownload: "CSV dosyasını indir ve güncelle!",
          withoutStatus: "DURUM YOK",
          loadingDataPleaseWait: "Veriler yükleniyor, lütfen bekleyin ...",
          startDate: "Başlangıç Tarihi",
          finalDate: "Bitiş Tarihi",
          partners: "Ortaklar",
          updateDashboardWithSelectedFilters:
            "Seçilen filtrelerle gösterge panelini güncelleyin",
          applyFilters: "Filtreleri Uygula",
          deviationsDividedByCause: "NEDENE GÖRE BÖLÜNMÜŞ SAPMALAR",
          deviationsDividedByJustification: "GEREKÇEYE GÖRE BÖLÜNMÜŞ SAPMALAR",
          adherence: "UYUMLULUK",
          quantity: "MİKTAR",
          staticDate: "STATİK TARİH",
          shippingDate: "SEVK TARİHİ",
          requestVersusReceiving: "TALEP X KABUL",
          period: "DÖNEM",
          requested: "TALEP EDİLEN",
          received: "KABUL EDİLEN",
          amountToReceive: "ALINACAK MİKTAR",
        },
      },
      dashboardTracking: {
        pageTitle: "Ortak Takip Gösterge Paneli",
        text: {
          dataTypeDoesNotExist: "Veri türü mevcut değil:",
          loadingDataPleaseWait: "Veriler yükleniyor, lütfen bekleyin ...",
          justifyPercentage: "Gerekçelerin Yüzdesi:",
          portalContract: "Portal Sözleşmesi",
          updateDashboardWithFilteredDara:
            "Seçilen filtrelerle gösterge panelini güncelleyin",
          applyFilters: "Filtreleri Uygula",
          dateFilter:
            "Tarih filtresi haftanın başlama ve bitiş tarihlerine göre ayarlanacaktır.",
          contractFilter:
            "Sözleşme filtresi, seçilen ortaklara göre doldurulacaktır.",
          planned: "PLANLANAN",
          weeklyDelivered: "HAFTALIK TESLİM",
          justification: "GEREKÇELER",
          total: "TOPLAM",
          over: "FAZLA",
          break: "KIRILMA",
          dailyDelivered: "GÜNLÜK TESLİM",
          quantity: "MİKTAR",
          delivered: "TESLİM EDİLEN",
          received: "KABUL EDİLEN",
          downloadCsvFile: "CSV dosyasını indir ve güncelle!",
        },
      },
      login: {
        pageTitle: "Giriş",
        text: {
          login: "Giriş",
          email: "E-posta",
          password: "Şifre",
          enter: "Giriş Yap",
          forgotPassword: "Şifremi Unuttum",
          emailRequired: "E-posta gerekli",
          passwordRequired: "Şifre gerekli",
          invalidEmail: "Geçersiz e-posta",
          invalidPassword: "Geçersiz şifre",
          loginFailed: "Giriş başarısız",
          invalidCredentials: "Geçersiz kimlik bilgileri",
          error: "Hata",
          ok: "Tamam",
          checkUserPassAndTryAgain:
            "Kullanıcı adı ve şifreyi kontrol edin ve tekrar deneyin",
          trygain: "Tekrar dene",
        },
      },
    },
    common: {
      id: "ID",
      name: "Ad",
      password: "Şifre",
      nickname: "Takma Ad",
      email: "E-posta",
      emails: "E-postalar",
      group: "Grup",
      groups: "Gruplar",
      address: "Adres",
      complement: "Ek",
      neighborhood: "Mahalle",
      city: "Şehir",
      state: "Eyalet/İl/Bölge",
      stateAbbreviation: "İl Kodu",
      country: "Ülke",
      postalCode: "Posta Kodu",
      phone: "Telefon",
      contact: "İletişim",
      contactPhone: "İletişim Telefonu",
      website: "Web Sitesi",
      yes: "Evet",
      no: "Hayır",
      ok: "Tamam",
      add: "Ekle",
      delete: "Sil",
      close: "Kapat",
      apply: "Uygula",
      cancel: "İptal",
      warning: "Uyarı!",
      attention: "DİKKAT!",
      Informative: "Bilgilendirme!",
      error: "Hata!",
      field: "Alan",
      fields: "Alanlar",
      value: "Değer",
      createdAt: "Oluşturulma Tarihi",
      acronym: "Kısaltma",
      sku: "Stok Kodu",
      skus: "Stok Kodları",
      skuId: "Stok Kodu ID",
      skuCode: "Stok Kodu",
      skuDescription: {
        label: "Stok Kodu Açıklaması",
        placeholder: "Stok kodu açıklamasını girin",
      },
      description: "Açıklama",
      language: "Dil",
      basicUnit: "Temel Birim",
      materialType: "Malzeme Türü",
      materialTypeDescription: "Malzeme Türü Açıklaması",
      center: "Merkez",
      centerDescription: "Merkez - Açıklama",
      distributionCenter: {
        label: "Dağıtım Merkezi",
        placeholder: "Merkezi belirtin",
      },
      local: "Yerel",
      category: "Kategori",
      release: "Sürüm",
      order: "Sipariş",
      causer: "Neden",
      back: "Geri",
      project: "Proje",
      quantity: "Miktar",
      actions: "İşlemler",
      origin: "Kaynak",
      origins: "Kaynaklar",
      skip: "Atla",
      historic: "Geçmiş",
      viewHistoric: "Geçmişi Görüntüle",
      plannedQuantity: "Planlanan Miktar",
      proposedQuantity: "Önerilen Miktar",
      producedQuantity: "Üretilen Miktar",
      orderQuantity: "Sipariş Miktarı",
      justify: "Gerekçelendir",
      generatedDiary: "Günlük Oluşturuldu",
      filter: "Filtre",
      filtered: "Filtreli",
      seeDetails: "Detayları Gör",
      monthYearRef: "Ay Yıl Ref.",
      date: "Tarih",
      initialDate: "Başlangıç Tarihi",
      finalDate: "Bitiş Tarihi",
      contractNumber: "Sözleşme Numarası",
      percentageConsumed: "Tüketilen Yüzde",
      day: "Gün",
      requestedIn: "Talep Edildiği Tarih",
      for: "İçin",
      requestedSku: "Talep Edilen Stok Kodu",
      requestedSkuId: "Talep Edilen Stok Kodu ID",
      selectedQuantity: "Seçilen Miktar",
      requestJustify: "Talep Gerekçesi",
      loadDate: "Yükleme Tarihi",
      proposalDate: "Öneri Tarihi",
      proposalSku: "Önerilen Stok Kodu",
      proposalSkuId: "Önerilen Stok Kodu ID",
      proposalQuantity: "Önerilen Miktar",
      proposalJustify: "Öneri Gerekçesi",
      warehouse: "Depo",
      contract: "Sözleşme",
      contractSap: "SAP Sözleşmesi",
      observationRule: "Gözlem Kuralı",
      exclusion: "Hariç Tutma",
      finish: "Tamamla",
      next: "Sonraki",
      prev: "Önceki",
      csvWithSuccess: "CSV Başarıyla İşlendi!",
      csvWithError: "CSV İşlenemedi",
      grip: "Uygunluk",
      shipmentDate: "Sevk Tarihi",
      deliveryDate: "Teslimat Tarihi",
      shipping: "Nakliye",
      orderNumber: "Sipariş Numarası",
      itemNumber: "Kalem Numarası",
      item: "Kalem",
      items: "Kalemler",
      balance: "Bakiye",
      amountReceived: "Alınan Miktar",
      quantityLoaded: "Yüklenen Miktar",
      expectedDeliveryDate: "Beklenen Teslim Tarihi",
      sapDeliveryDate: "SAP Teslim Tarihi",
      lastLoadDate: "Son Yükleme Tarihi",
      destination: "Hedef",
      loadHistory: "Yükleme Geçmişi",
      showLoadHistory: "Yükleme Geçmişini Göster",
      originCenter: "Kaynak Merkez",
      boardingDate: "Yükleme Tarihi",
      invoice: "Fatura",
      observations: "Gözlemler",
      report: "Rapor",
      attachReport: "Rapor Ekle",
      downloadReport: "Raporu İndir",
      deleteReport: "Raporu Sil",
      measurementUnit: "Ölçü Birimi",
      save: "Kaydet",
      material: "Malzeme",
      materialDescription: "Malzeme - Açıklama",
      sapQuantity: "SAP Miktarı",
      partnerQuantity: "Ortak Miktarı",
      distinction: "Fark",
      otpions: "Seçenekler",
      edit: "Düzenle",
      skuIdDelivery: "Teslim Edilecek Stok Kodu ID",
      palletizing: "Paletleme",
      loadingDate: "Yükleme Tarihi",
      loading: "Yükleme",
      originDeposit: "Kaynak Depo",
      destinationCenter: "Hedef Merkez",
      destinationDeposit: "Hedef Depo",
      itIs: "Bu",
      are: "Bu",
      noResults: "Sonuç Yok",
      step: "Adım",
      searchDistributionCenter: "Dağıtım Merkezi Ara",
      statusBooking: "Rezervasyon Durumu",
      canceled: "İPTAL EDİLDİ",
      reset: "Sıfırla",
      partner: "Ortak",
      partners: "Ortaklar",
      week: "Hafta",
      status: "Durum",
      deviation: "Sapma",
      recover: "Kurtar",
      compensationDate: "Telafi Tarihi",
      compensationWeek: "Telafi Haftası",
      accomplishedQuantity: "Gerçekleştirilen Miktar",
      quantityDeviation: "Miktar Sapması",
      compensation: "Telafi",
      compensationQuantity: "Telafi Miktarı",
      weekCompensation: "Hafta Telafisi",
      contractTotalQuantiy: "Toplam Sözleşme Miktarı",
      percentageProduced: "Üretilen Yüzde",
      percentageOfContractTime: "Sözleşme Süresinin Yüzdesi",
      endDate: "Bitiş Tarihi",
      minimalVariation: "Minimum Değişiklik",
      maximumVariation: "Maksimum Değişiklik",
      requested: "Talep Edilen",
      received: "Alınan",
      water: "SU",
      harbor: "LİMAN",
      awaitingBilling: "FATURALAMA BEKLİYOR",
      bookingStatus: "Rezervasyon Durumu",
      purchasingDocument: "Satın Alma Belgesi",
      shipmentQuantity: "Sevk Miktarı",
      staticShippingDate: "Statik Sevk Tarihi",
      stockEntryForecast: "Stok Girişi Tahmini",
      entryIntoStock: "Stoğa Giriş",
      deliveredQuantity: "Teslim Edilen Miktar",
      justification: "Gerekçe",
      otif: "OTIF",
      fileUpload: {
        resultProcessingFile: "Dosya işleme sonucu:",
        fileSize: "Dosya boyutu bayt cinsinden:",
        lastModifiedDate: "Son değişiklik tarihi:",
        submit: "Gönder",
        selectFileForDetails: "Detayları görmek için bir .csv dosyası seçin...",
        uploadFile: "Dosya Yükle",
        selectFileFirst: "Önce bir dosya seçin",
      },
      stepLogsHistoryDetalhe: {
        modal: {
          title: "{{name}} id {{id}} öğesinin değişiklik geçmişi",
        },
      },
      dashboardFilters: {
        form: {
          label: "Hangi tür verileri yüklemek istersiniz?",
          buttonGeneralData: "Genel Veriler",
          buttonSpecieficPartner: "Belirli Ortak",
          errorDate: "Başlangıç ve bitiş tarihi seçmelisiniz!",
          maxDateError: "Seçilen süre 90 günden fazla olamaz!",
          lastQuarter: "Son çeyrek",
          specificPeriod: "Belirli Dönem",
          startDate: "Başlangıç Tarihi",
          endDate: "Bitiş Tarihi",
          loadData: "Verileri al ve gösterge panelini yükle",
        },
      },
      autoComplete: {
        centro: {
          label: "Dağıtım merkezini ara",
        },
        centroVirtual: {
          label: "Sanal merkezi ara",
        },
        contrato: {
          label: "Sözleşmeyi ara",
        },
        email: {
          label: "E-postayı ara",
        },
        justificativa: {
          label: "Gerekçeyi ara",
        },
        listaTecnica: {
          label: "Stok Kodunu Ara",
        },
        parceiro: {
          label: "Ortağı ara",
        },
        projeto: {
          label: "Projeyi ara",
        },
        propriedade: {
          label: "Parametreyi ara",
        },
      },
    },
    global: {
      button: {
        new: "Yeni",
        edit: "Düzenle",
        delete: "Sil",
        save: "Kaydet",
        cancel: "İptal",
        back: "Geri",
        search: "Ara",
        filter: "Filtrele",
        clear: "Temizle",
        close: "Kapat",
        add: "Ekle",
        remove: "Kaldır",
        yes: "Evet",
        no: "Hayır",
        ok: "Tamam",
        apply: "Uygula",
        reset: "Sıfırla",
        download: "İndir",
        upload: "Yükle",
        approve: "Onayla",
        disapprove: "Reddet",
        proceed: "İlerle",
        continue: "Devam et",
        send: "Gönder",
        generate: "Oluştur",
        view: "Görüntüle",
        confirm: "Onayla",
        exit: "Çıkış",
        step: "Adım",
        skip: "Atla",
      },
      table: {
        dateAndHour: "Tarih ve Saat",
        user: "Kullanıcı",
        description: "Açıklama",
        contractNumber: "Sözleşme Numarası",
        freight: "Nakliye",
        startVigency: "Başlangıç Tarihi",
        endVigency: "Bitiş Tarihi",
        itemQuantity: "Ürün Miktarı",
        consumption: "Tüketim",
        seeDetails: "Detayları Gör",
        group: "Grup",
        parameter: "Parametre",
        value: "Değer",
        order: "Sipariş",
        item: "Kalem",
        skuDescription: "Stok Kodu Açıklaması",
        loadedQuantity: "Yüklenen Miktar",
        loadingDate: "Yükleme Tarihi",
        deliveryDate: "Teslim Tarihi",
        truckPlate: "Tır Plakası",
        truckHorsePlate: "Çekici Plakası",
        breakQuantity: "Kırık Miktarı",
        breakJustification: "Kırık Gerekçesi",
        sapCode: "SAP Kodu",
        day: "Gün",
        partner: "Ortak",
        contract: "Sözleşme",
        skuId: "Stok Kodu ID",
        productionMade: "Gerçekleşen Üretim",
        productionReceived: "Alınan Üretim",
        justification: "Gerekçe",
        averagePrice: "Ortalama Fiyat",
        activity: "Faaliyet",
        subActivity: "Alt Faaliyet",
        family: "Aile",
        subGroup: "Alt Grup",
        center: "Merkez",
        protein: "Protein",
        week: "Hafta",
        sapContract: "SAP Sözleşmesi",
        origin: "Kaynak",
        name: "Ad",
        reference: "Referans",
        status: "Durum",
        step: "Adım",
        partnerAggregated: "Birleştirilmiş Ortak",
      },
      tooltip: {
        downloadFileAndUpdate: "Güncelleme ve yükleme için dosyayı indir!",
        deleteOrigin: "Kaynağı Sil",
        changesHistory: "Değişiklik Geçmişi",
        addNewOrigin: "Yeni Kaynak Ekle",
        closeModal: "Modali Kapat",
        newParameter: "Yeni Parametre",
        updateParameter: "Parametreyi Güncelle",
      },
      message: {
        rowUpdatedSuccessfully: "Kayıt başarıyla güncellendi!",
        rowUpdatedFillingTheFields: "Kayıt eklendi, lütfen verileri doldurun.",
        rowDeletedSuccessfully: "Kayıt başarıyla silindi!",
        warning: "Uyarı!",
        selectPartner:
          "Bu özelliği kullanabilmek için bir ortak seçmeniz gerekiyor!",
        selectPartnerFirst:
          "Bu özelliğe erişmeden önce bir ortak seçmelisiniz.",
        selectPartnerToContinue:
          "Bu özelliğe erişmek için önce bir ortak seçmelisiniz.",
        selectPartnerBelow:
          "Devam etmek için aşağıdan bir ortak seçin:",
        partnerSelectionRequired: "Ortak seçimi gerekli",
        partnerSelectionHint:
          "İpucu: Başlıktaki ortak adının yanındaki simgeye tıklayarak istediğiniz zaman ortak değiştirebilirsiniz.",
        parameterDeleted: "Parametre başarıyla silindi!",
        partnerAdded: "Birleştirilmiş Ortak başarıyla eklendi!",
        partnerUpdated: "Birleştirilmiş Ortak başarıyla güncellendi!",
        propertyAddWithSuccess: "Özellik başarıyla eklendi!",
        propertyUpdatedWithSuccess: "Özellik başarıyla güncellendi!",
      },
      dialog: {
        deletePartnerAggregated:
          "Birleştirilmiş Ortağı gerçekten silmek istiyor musunuz?",
        deletePartnerAggregatedSubTitle:
          "Birleştirilmiş Ortağı silmeyi talep ettiniz.",
        providerCode: "Sağlayıcı Kodu: ",
        confirmOperation: "İşlemi onaylıyor musunuz?",
      },
    },
  },
};
